import type React from "react";

import type { ModalBaseProps } from "@/components/Modal/Modal";
import { Modal } from "@/components/Modal/Modal";
import { Button } from "@/design-system/Button";
import { SUPPORT_EMAIL } from "@/helpers/constants";
import { Trans, useTranslation } from "@/translations";

type AddProjectModalProps = ModalBaseProps;

export function AddProjectModal({ isOpened, onOpenChange }: AddProjectModalProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Modal.Root
      title={t("page.portfolio.add-new-project.modal.title")}
      description={
        <Trans
          i18nKey="page.portfolio.add-new-project.modal.description"
          components={{
            email: (
              <a className="text-text-brand" href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </a>
            ),
          }}
        />
      }
      {...{ isOpened, onOpenChange }}
      size="md"
    >
      <Modal.Actions>
        <Modal.Close>
          <Button>{t("common.action.close")}</Button>
        </Modal.Close>
      </Modal.Actions>
    </Modal.Root>
  );
}
